<template>
  <div class="room-controls-component">
    <div class="room-controls">
      <div class="room-controls-start">
        <div class="room-info">
          <div class="room-info-title-wrapper">
            <VButton
                    v-if="isRoomMode('group')"
                    :icon="(isMobile || isParticipantRole()) ? '' : 'setting_white'"
                    class="room-group-setting-button small group"
                    :class="{ 'pointer-events-none': isParticipantRole() }"
                    @click="onToggleGroupSettingModal"
            >{{ $t("control.groupDiscussion") }}{{me.roomGroupId == undefined || me.roomGroupId === 'default'? '' : ' (' +getRoomGroupName(me.roomGroupId)+')'}}</VButton>
            <div v-if="isWebinar" class="room-live-status">{{ currentWebinarType === 'wall' ? 'class' : currentWebinarType }}</div>
            <GrmIcon icon="lock-blue"
                     v-if="useDefinePasswd"
            />
            <p class="room-info-title">{{room.roomTitle}}</p>
          </div>
          <div class="room-info-user-count-wrapper">
            <p class="room-info-user-count"
               @click="e => {
                let now = Date.now();
                if(now - (e.target._last_time || 0) > 2000){
                  e.target._cnt = 0;
                }
                e.target._last_time = now;
                e.target._cnt++;
                if(e.target._cnt >= 5){
                  e.target._cnt = 0;
                  openLogMonitorPage();
                }
              }"
            >{{roomUserCount}}</p>
          </div>
        </div>
      </div>
      <div class="room-controls-center" :class="{ isOpen: isShowMobileControls }">
        <div class="room-control-list-wrapper">
          <ul class="room-control-list">
            <li class="room-control-item"><button class="room-control-button speaker"
              :data-device-status="me.speakerStatus"
              :data-device-role="isEnableDevice('speaker')"
              v-tooltip.bottom="isEnableDevice('speaker') ? $t('control.device.setting.speaker') : $t('control.noRole')"
              @click="onToggleUserDeviceStatus({deviceType:'speaker'})"
            >
                <span class="room-control-button-text">{{ $t("common.device.speaker") }}</span>
              </button>
            </li>
            <li class="room-control-item"><button class="room-control-button cam" 
              :data-device-role="isEnableDevice('camera')"
              :data-device-status="me.cameraStatus"
              v-tooltip.bottom="isEnableDevice('camera') ? $t('control.device.setting.camera') : $t('control.noRole')"
              @click="onToggleUserDeviceStatus({deviceType:'camera'})"
            >
                <span class="room-control-button-text">{{ $t("common.device.camera") }}</span>
              </button>
            </li>
            <li class="room-control-item rotate-camera">
              <button class="room-control-button rotate-camera"
                v-tooltip.bottom="'카메라 전환'"
                @click="onToggleRotateCamera"
            >
              <span class="room-control-button-text">{{ $t("control.device.cameraRotate") }}</span>
            </button>
            </li>
            <li class="room-control-item"
                v-if="me.micStatus !== 'none'"
            ><button class="room-control-button mic py-1 flex flex-col items-center"
              :data-device-status="me.micStatus"
              :data-device-role="isEnableDevice('mic')"
              v-tooltip.bottom="micTooltip" 
              @click="onToggleUserDeviceStatus({deviceType:'mic'})"
            >
              <span v-if="useStt" class="text-sm text-white leading-3">STT</span>
              <span class="room-control-button-text">{{ $t("common.device.mic") }}</span>
            </button></li>
            <li v-if="useInterpreting"
                class="room-control-item"><button class="room-control-button interpreting"
              @click="onToggleInterpretingModal"
            >
              <span class="room-control-button-text">{{ $t("control.translation") }}</span>
            </button></li>
            <li class="room-control-item">
              <button class="room-control-button setting"
              v-tooltip.bottom="$t('common.setting')"
              ref="settingBtn"
              @click="onToggleSettingMenu()"
            >
                <span class="room-control-button-text">{{ $t("common.setting") }}</span>
              </button>
            </li>
            <li class="room-control-item"
                v-if="isFullscreenEnabled"
            ><button class="room-control-button size"
                                                  :class="isFullScreen ? 'decrease' : 'increase'"
                                                  v-tooltip.bottom="$t('control.fullScreen')"
                                                  @click="onToggleFullScreen">
              <span class="room-control-button-text">{{ $t("control.fullScreen") }}</span>
            </button></li>
          </ul>
        </div>
      </div>
      <div class="room-controls-end">
        <div class="room-sub-controls">
          <div class="room-sub-control-list-wrapper">
            <ul class="room-sub-control-list">
              <li v-if="useVoiceRequest"
                  class="room-sub-control-item">
                <button class="room-sub-control-button voice-request">
                  <VoiceRequest />
                </button>
              </li>
              <li v-if="useTranslation" class="room-sub-control-item translation">
                <BtnTranslation/>
              </li>
              <li v-if="useMeetingNote" class="room-sub-control-item meeting-note">
                <BtnMeetingNote/>
              </li>
              <li v-if="useClientRecord" class="room-sub-control-item record">
                <BtnRecord/>
              </li>
              <li v-if="useInviteRoom" class="room-sub-control-item invite">
                <button
                  class="room-sub-control-button invite"
                  @click="onToggleInviteModal"
                />
              </li>
              <li class="room-sub-control-item">
                <button
                  class="room-sub-control-button mobile-controls"
                  @click="onToggleMobileControls"
                >{{ $t("common.device.name") }}</button>
              </li>
              <li class="room-sub-control-item">
                <button
                  class="room-sub-control-button extend-menu-toggle"
                  :class="{ close: isOpenExtendMenu }"
                  v-tooltip.bottom-end="isOpenExtendMenu ? $t('control.extendMenu.close.tooltip') : $t('control.extendMenu.open.tooltip')"
                  @click="$emit('update:isOpenExtendMenu', !isOpenExtendMenu)"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="select-setting-box" ref="settingMenu" v-show="isShowSettingMenu" tabindex="-1" @blur="blurSettingMenu($event)">
      <div class="select-setting-item roomSetting"
           @click="onToggleSettingModal">{{ $t("control.setting.room") }}</div>
      <div class="select-setting-item deviceSetting"
           @click="onToggleDeviceSettingModal">{{ $t("control.setting.device") }}</div>
      <div class="select-setting-item deviceSetting"
           v-if="isMixingCallType"
           @click="onToggleQualitySettingModal">{{ $t("control.setting.video") }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import { RoomCall } from "@/core/api/room.call.api";
import { RoomCallStream } from "@/core/api/room.call.stream.api";

import {Device} from "@/utils";

import VoiceRequest from "@/components/Room/Voice/Request";
import RoomInvite from "@/components/Room/Invite/RoomInvite";
import RoomInterpretingModal from '@/components/Room/Interpreting/Modal'
import RoomSettingModal from '@/components/Room/SettingRenew/Modal'
import RoomDeviceSettingModal from '@/components/Room/DeviceSetting/Modal'
import RoomQualitySettingModal from '@/components/Room/DisplayQuality/Modal'
import BtnRecord from "@/components/Room/ExtendMenu/RoomRecord/BtnRecord";
import GrmIcon from "@/components/Common/icon/GrmIcon";
import BtnMeetingNote from "@/components/Room/ExtendMenu/RoomMeetingNote/BtnMeetingNote.vue"
import VButton from "@/components/Common/VButton.vue";
import GroupSettingModal from "@/components/Room/Group/SettingModal.vue";
import BtnTranslation from "@/components/Room/ExtendMenu/RoomTranslation/BtnTranslation.vue";

export default {
  name: 'RoomControls',
  components: {
    BtnTranslation,
    VButton,
    GrmIcon,
    VoiceRequest,
    BtnRecord,
    BtnMeetingNote,
  },
  props: {
    isOpenExtendMenu: Boolean,
  },
  data(){
    return {
      useInterpreting: false,
      isShowSettingMenu: false,
      isShowMobileControls: false,
    }
  },
  computed: {
    ...mapGetters('room', [
      'room',
      'roomUserCount',
      'isRoomMode',
      'isFullScreen',
      'deviceSettings',
      'useDefinePasswd',
      'roomInfoSetting',
      'roomInfo',
      'isEdu'
    ]),
    ...mapGetters('user', [
        'me',
        'isGuest',
        'hasEmceeRole',
        'isParticipantRole'
    ]),
    ...mapGetters('call', [
        'callType',
        'isP2PCallType',
        'isMixingCallType',
        'isWebinar',
        'currentWebinarType',
        'isWebinarLive',
    ]),
    ...mapGetters('roomGroup', [
      'getRoomGroupName'
    ]),
    useVoiceRequest() {
      return this.isEdu
    },
    useStt(){
      return this.roomInfoSetting?.['useStt']
    },
    useMeetingNote() {
      return this.roomInfoSetting?.['useMeetingNote'];
    },
    useInviteRoom() {
      return this.roomInfoSetting?.['useInviteRoom'];
    },
    useTranslation() {
      return this.roomInfoSetting?.['useTranslation']
    },
    useClientRecord() {
      return this.roomInfoSetting?.['useClientRecord']
    },
    micTooltip(){
      if(!this.isEnableDevice('mic')){
        return this.$t('control.noRole')
      }else if(!this.useStt){
        return this.$t('control.device.setting.mic')
      }else{
        if(this.me.micStatus === 'on'){
          return this.$t('control.device.setting.stt.on')
        }else{
          return this.$t('control.device.setting.stt.off')
        }
      }
    },
    isEnableDevice(){
      return (deviceType) => {
        if(!deviceType) return;

        const {roomUserRole} = this.me;
        if(!roomUserRole) return;

        const {roleId} = roomUserRole;

        if(['camera', 'mic'].includes(deviceType) && this.isWebinarLive){
          return roleId === 'speaker' && roomUserRole[deviceType];
        }else{
          return roomUserRole[deviceType];
        }
      }
    },
    isParticipant(){
      if(!this.me.roomUserRole) return true;
      return this.me.roomUserRole.roleId === 'participant' ? true : false;
    },
    isMobile() {
      return Device.isMobile();
    },
    isFullscreenEnabled(){
      const docu = this.getDocument();
      return docu.fullscreenEnabled || docu.webkitFullscreenEnabled;
    },
  },
  watch:{
    isShowSettingMenu(){
      if(this.isShowSettingMenu){
        this.$nextTick(() => {
          const settingMenu = this.$refs.settingMenu;
          const settingBtn = this.$refs.settingBtn;

          settingMenu.style.top =  (settingBtn.getBoundingClientRect().top + 55) + 'px';
          settingMenu.style.left = (settingBtn.offsetLeft - settingMenu.offsetWidth/4) + 'px'

          if(this.isMobile){
            settingMenu.style.left = (settingBtn.getBoundingClientRect().left - settingMenu.offsetWidth/4) + 'px';
          }
          settingBtn.blur();
          settingMenu.focus();
        })
      }
    }
  },
  created() {
    // this.$modal(RoomInterpretingModal, { exist: true })
  },
  methods: {
    ...mapActions('user', [
        'toggleUserDeviceStatus'
    ]),
    ...mapActions('call', [
        'devices',
        'openLogMonitorPage'
    ]),
    ...mapActions('room',[
      'saveDeviceSettings'
    ]),
    ...mapMutations('room', [
        'TOGGLE_FULL_SCREEN'
    ]),
    onToggleGroupSettingModal() {
      this.$modal(GroupSettingModal)
    },
    onToggleInviteModal() {
      this.$modal(RoomInvite)
    },
    onToggleInterpretingModal() {
      // this.useInterpreting && this.$modal(RoomInterpretingModal)
    },
    onToggleDeviceSettingModal() {
      this.isShowSettingMenu = false
      this.$modal(RoomDeviceSettingModal)
    },
    onToggleSettingMenu(){
      this.isShowSettingMenu = !this.isShowSettingMenu;
    },
    onToggleSettingModal() {
      this.isShowSettingMenu = false
      this.$modal(RoomSettingModal)
    },
    onToggleQualitySettingModal(){
      this.isShowSettingMenu = false
      this.$modal(RoomQualitySettingModal)
    },
    onToggleFullScreen() {
      this.TOGGLE_FULL_SCREEN();
    },
    async onToggleRotateCamera() {
      // let current;
      const deviceId = await (async () => {
        let front;
        let back;
        // alert('@@ 0:'+ (()=>{
        //   return this.devices.videoinput.map((d, idx) => {
        //     return `##[${idx}]${d.label}`;
        //   });
        // })())

        // this.devices.videoinput.forEach((device) => {
        //   const frontDevice = (() => {
        //     if (Device.isIOS()) {
        //       return device.label.indexOf('전면') > -1 || device.label.indexOf('Front') > -1
        //     }
        //     return device.label.indexOf('front') > -1;
        //   })();
        //   const backDevice = (() => {
        //     if (Device.isIOS()) {
        //       return device.label.indexOf('후면') > -1 || device.label.indexOf('Back') > -1
        //     }
        //     return device.label.indexOf('back') > -1;
        //   })();
        //
        //   if (frontDevice) {
        //     front = device;
        //   } else if (backDevice) {
        //     back = device;
        //   }
        //
        //   const currentVideoId = RoomCallStream.getLocalDeviceSetting().video.deviceId;
        //   if (currentVideoId === device.deviceId) {
        //     current = device;
        //   }
        // });

        const currentVideoId = RoomCallStream.getLocalDeviceSetting().video.deviceId
        let currentDeviceIndex = 0;
        const devices = await this.devices();
        const frontDevices = [], backDevices = [];
        devices.videoinput.forEach((device, idx) => {
          if(device.deviceId === currentVideoId){
            currentDeviceIndex = idx;
          }
          let label = device.label.toLowerCase();
          if(
            label.includes('전면')
            || label.includes('front')
          ){
            frontDevices.push(device);
          }else if(
            label.includes('후면')
            || label.includes('back')
          ){
            backDevices.push(device);
          }
        });
        frontDevices.sort((a,b) => a.label.localeCompare(b.label));
        backDevices.sort((a,b) => a.label.localeCompare(b.label));
        front = frontDevices[0];
        back = backDevices[0];

        let change;
        // console.log(`ch camera : current[${currentVideoId}], front[${front?.deviceId}], back[${back?.deviceId}]`)

        if(front && back){
          if (currentVideoId === front.deviceId) {
            change = back;
          } else {
            change = front;
          }
        }else{
          let idx = currentDeviceIndex + 1;
          if (idx+1 >= devices.videoinput.length) {
            idx = 0;
          }
          change = devices.videoinput[idx];
        }

        if (!change) {
          return;
        }

        return change.deviceId;
      })();

      if (!deviceId) {
        return;
      }

      RoomCall.changeUserDevice({
        deviceType: 'video', 
        deviceId
      });

      const deviceSettings = { video: { deviceId } }
      this.saveDeviceSettings({ deviceSettings });
    },
    onToggleMobileControls() {
      this.isShowMobileControls = !this.isShowMobileControls
    },
    blurSettingMenu(event){
      if(event.relatedTarget == this.$refs.settingBtn) return;
      this.isShowSettingMenu = false;
    },
    onToggleUserDeviceStatus({deviceType}){
      if(this.isEnableDevice(deviceType)){
        this.toggleUserDeviceStatus({deviceType})
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.room-controls {
  height: 100%;
  padding-left: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  background-color: #4f4e5c;
  display: flex;
  justify-content: space-between;
  position: relative;
  color: #fff;
}
.room-controls-start {
  flex: 1;
  min-width: 0;
  padding-right: 20px;
  display: flex;
}
.room-info {
  width: 100%;
  display: flex;
  align-items: center;
}
.room-info-title-wrapper {
  min-width: 0;
  max-width: max-content;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0 10px;
}
.room-info-badge {
  height: 26px;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 12px;
  color: #fff;
  line-height: 26px;
  text-align: center;
  white-space: nowrap;
  &.group {
    background-color: #4bbbc0;
  }
}
.room-live-status {
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #f05;
  font-size: 14px;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
}
.room-info-title {
  font-weight: 700;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 28px;
}
.room-info-user-count-wrapper {
  display: flex;
  align-items: center;
  &::before {
    content: '';
    width: 1px;
    height: 14px;
    margin: 0 14px;
    background-color: rgba(255, 255, 255, 0.4);
    display: block;
  }
}
.room-info-user-count {
  padding-left: 18px;
  background: url('~@/assets/images/userCount_white.svg') no-repeat center left / 12px auto;
  font-size: 14px;
  font-weight: 700;
  color: $mainColor;
}
.room-controls-center {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  justify-content: center;
}
.room-control-list-wrapper {}
.room-control-list {
  height: 100%;
  display: flex;
}
.room-control-item {
  &.rotate-camera {
    display: none;
  }
}
.room-control-button {
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  transition: 0.1s ease-out;
  &::before {
    content: '';
    width: 20px;
    height: 100%;
    display: block;
    pointer-events: none;
  }

  $devices: mic, cam, speaker;
  @each $device in $devices {
    &.#{$device} {
      &[data-device-status="on"] {
        &::before {
          background: url('~@/assets/images/#{$device}_on_white.svg') no-repeat center / 100% auto;
        }
      }
      &[data-device-status="off"] {
        &::before {
          background: url('~@/assets/images/#{$device}_off_red.svg') no-repeat center / 100% auto;
        }
      }
      &:not([data-device-role="true"]) {
        cursor:not-allowed;
        opacity: 0.3;
        &::before {
          background: url('~@/assets/images/#{$device}_off_gray.svg') no-repeat center / 100% auto;
        }
      }
    }
  }
  &.rotate-camera {
    &::before {
      width: 24px;
      background: url('~@/assets/images/rotate_white.svg') no-repeat center / 100% auto;
    }
  }
  &.interpreting {
    &::before {
      width: 30px;
      background: url('~@/assets/images/interpreter_white.svg') no-repeat center / 100% auto;
    }
  }
  &.setting {
    &::before {
      background: url('~@/assets/images/setting_white.svg') no-repeat center / 100% auto;
    }
  }
  &.size {
    &.increase {
      &::before {
        background: url('~@/assets/images/screen_increase_white.svg') no-repeat center / 100% auto;
      }
    }
    &.decrease {
      &::before {
        background: url('~@/assets/images/screen_decrease_white.svg') no-repeat center / 100% auto;
      }
    }
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
    &::after {
      content: '';
      width: 100%;
      height: 1px;
      background-color: #0cf;
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }
}
.room-control-button-text {
  display: none;
}
.room-controls-end {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: flex-end;
}
.room-sub-controls {
  height: 100%;
}
.room-sub-control-list-wrapper {
  height: 100%;
}
.room-sub-control-list {
  height: 100%;
  display: flex;
}
.room-sub-control-item {}
.room-sub-control-button {
  min-width: 50px;
  height: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: 0.1s ease-out;
  &.voice-request {
    padding: 0 12px;
    font-size: 13px;
    color: #fff;
    &::before {
      content: '';
      width: 20px;
      height: 100%;
      background: url('~@/assets/images/voiceRequest_white.svg') no-repeat center / 100% auto;
      display: block;
      pointer-events: none;
      z-index: 1;
    }
  }
  &.invite {
    &::before {
      content: '';
      width: 24px;
      height: 100%;
      background: url('~@/assets/images/userInvite_white.svg') no-repeat center / 100% auto;
      display: block;
      pointer-events: none;
    }
  }
  &.extend-menu-toggle {
    background: rgba(0, 0, 0, 0.3);
    &::before {
      content: '';
      width: 16px;
      height: 100%;
      background: url('~@/assets/images/menu_white.svg') no-repeat center / 100% auto;
      display: block;
      pointer-events: none;
      transition: 0.2s ease-out;
    }
    &.close {
      background: rgba(0, 0, 0, 0.5);
      &::before {
        background: url('~@/assets/images/arrowLineThickRight_white.svg') no-repeat center / 100% auto;
      }
    }
  }
  &.mobile-controls {
    padding: 0 10px;
    font-size: 13px;
    display: none;
    &::before {
      content: '';
      width: 16px;
      height: 100%;
      margin-right: 4px;
      background: url('~@/assets/images/controls_white.svg') no-repeat center / 100% auto;
      display: block;
      pointer-events: none;
    }
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.5);
    &::after {
      content: '';
      width: 100%;
      height: 1px;
      background-color: #0cf;
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }
}
.select-setting-box{
	position: absolute;
	width: 100px;
	border-radius: 5px;
	background-color: #fff;
  box-shadow: 4px 10px 30px rgb(0 0 0 / 40%);
	font-size: 12px;
	color: #111;
  text-align: center;

	.select-setting-item{
		padding: 8px;
		cursor: pointer;

		&:not(:first-child){
			border-top: 1px solid #c8c8c8;
		}
	}
}

[grm-device-mobile] {
  .room-info-title-wrapper{
    gap: 0 6px;
  }
  .room-info-user-count-wrapper {
    display: none;
  }
  .room-controls-center {
    width: 100%;
    height: 82px;
    position: absolute;
    top: 50px;
    right: 0;
    left: 0;
    overflow: hidden;
    pointer-events: none;
    &.isOpen {
      .room-control-list-wrapper {
        transform: translate(0, 0);
      }
    }
  }
  .room-controls-end {
    flex: initial;
  }
  .room-control-list-wrapper {
    width: 100%;
    transform: translate(0, -100%);
    transition: 0.3s ease-out;
    pointer-events: auto;
  }
  .room-control-list {
    padding: 16px;
    background-color: rgba(44, 48, 53, 0.9);
  }
  .room-control-item {
    flex: 1;
    display: flex !important;
    justify-content: center;
  }
  .room-sub-control-item {
    &.record{
      display: none;
    }
  }
  .room-sub-control-button {
    &.mobile-controls {
      display: flex;
    }
  }
  .room-control-button {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:hover {
      background-color: transparent;
      &::after {
        content: none;
      }
    }
  }
  .room-control-button-text {
    display: block;
    font-size: 11px;
    color: #fff;
  }
  .room-group-setting-button{
    &.group{
      min-width: 69px;
      font-size: 12px;
      line-height: 14px;
    }
  }
}
</style>